import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=55e7fba9&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"
import style0 from "./Credit.vue?vue&type=style&index=0&id=55e7fba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e7fba9",
  null
  
)

export default component.exports